e4.cart = {
    currentQuantity: {
        productLinesCount: 0,
        productQuantity: 0
    },
    init: function() {
        if ( jQuery( '.js-e-cart-form' ).length === 1 ) {
            e4.require.js( e4.settings.require.handlebars, function() {
                e4.handlebars.registerHelpers( 'compare' );
                e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-cart-orderlines #js-e-handlebars-tmpl-cart-buttons #js-e-handlebars-tmpl-cart-footer-buttons #js-e-handlebars-tmpl-order-summary' );
                // ATTENTION: Please note that all product-add/remove events are trigger on jQuery( document ) and not
                // the cart element.
                e4.cart.event = e4.util.registerEvents( 'load loaded update updated productadd productadded productremove productremoved orderlinedelete orderlinedeleted orderlineincrease orderlinedecrease', 'cart' );
                e4.cart.saveInternalBackLink();
                e4.cart.bindEvents();
                e4.cart.orderline.bindEvents();
                e4.cart.load();
            } );
            window.addEventListener('beforeunload', function (e) {
                if(e4?.cart?.cartHasUnsavedChanges === true && e4.cart.preventBeforeUnload === false) {
                    e.preventDefault(); 
                    e.returnValue = true;
                    jQuery( '.js-eldorado-manual-cart-alert' ).addClass('alert-pulse')
                }
            });
            jQuery(document).on('click', 'a', function (event) {
                e4.cart.awaitSaveBasketIfUnsavedChanges();
            });
        } else if ( jQuery( '.js-e-cart-quantity' ).length > 0 ) {
            e4.cart.event = e4.util.registerEvents( 'productadd productadded productremove productremoved', 'cart' );
            e4.cart.updateQuantityInfo();
            e4.cart.msg.init();
        }
    },
    bindEvents: function() {
        jQuery( document ).on( 'click', '.js-e-cart-back-link', e4.cart.goToInternalBackLink ).find( '.js-e-cart-form' ).on( 'submit', function( event ) {
            event.preventDefault();
        } )
        jQuery( '.js-e-cart' ).on( 'click', '.js-eldorado-recalculate-cart', () => {
            e4.cart.orderline.update( e4.cart.orderline.lastEdited );
        } );
    },
    ajax: function( objAjaxSettings, fnCallback, isQuantityRequest ) {
        var jCart = jQuery( '.js-e-cart' ),
            jqXHR = jQuery.ajax( jQuery.extend( {
                url: `${ isQuantityRequest ? e4.settings.ecom.cartCount.url : e4.settings.ecom.cart.url }`,
                method: 'POST',
                dataType: 'json',
                cache: false,
                beforeSend: function() {
                    if ( jCart.length === 1 ) {
                        jQuery( '.js-e-cart-main, .js-e-cart-aside' ).find( '.js-e-loading-overlay' ).addClass( 'is-loading' );
                    }
                }
            }, objAjaxSettings ) );
        jqXHR.done( function( data ) {
            if ( typeof fnCallback === 'function' ) {
                fnCallback( data );
            }
            if ( jCart.length === 1 ) {
                jQuery( '.js-e-cart-main, .js-e-cart-aside' ).find( '.js-e-loading-overlay' ).removeClass( 'is-loading' );
            }
        } );
        return jqXHR;
    },
    load: function() {
        var jCart = jQuery( '.js-e-cart' );
        jCart.trigger( e4.cart.event.load );
        e4.cart.ajax( {
            method: 'GET'
        }, function( jsonData ) {
            e4.cart.updateContent( jsonData );
            e4.loading.resolveWait( '.js-e-cart-main' );
            e4.loading.resolveWait( '.js-e-cart-aside' );
            jCart.trigger( e4.cart.event.loaded, jsonData );
        } );
    },
    saveInternalBackLink: function() {
        if ( document.referrer.indexOf( location.protocol + '//' + location.host ) === 0 && document.referrer.indexOf( '/shop/cart/checkout' ) === -1 ) {
            sessionStorage.setItem( e4.settings.ecom.cart.storageKeyInternalBackLink, document.referrer );
        }
    },
    awaitSaveBasketIfUnsavedChanges: async function () {
        if (e4?.cart?.cartHasUnsavedChanges) {
            e4.cart.preventBeforeUnload = true;
            
            var saveCartMessage = $('<div style="position:fixed;top:0;bottom:0;left:0;right:0;background-color:rgba(255,255,255,1);z-index:99999;display:flex;align-items:center;justify-content:center;"></div>').get(0);
            saveCartMessage.textContent = $('#custom-cart-alert')?.data('saving-cart-translation');
            document.body.append(saveCartMessage);
            
            await e4.cart.orderline.update(e4.cart.orderline.lastEdited);
            
            saveCartMessage.remove();
            e4.cart.preventBeforeUnload = false;
        }
    },
    goToInternalBackLink: function( event ) {
        e4.cart.awaitSaveBasketIfUnsavedChanges();
        var strInternalBackLink = sessionStorage.getItem( e4.settings.ecom.cart.storageKeyInternalBackLink );
        if ( strInternalBackLink !== null && strInternalBackLink.indexOf( location.protocol + '//' + location.host ) === 0 ) {
            event.preventDefault();
            location.href = strInternalBackLink;
        }
    },
    addProduct: function( objProductFormData, fnCallback ) {
        var jDocument = jQuery( document ),
            jCart = jDocument.find( '.js-e-cart' );
        var objProductData = {
            CartCmd: 'add',
            ProductID: '',
            VariantID: '',
            Quantity: 1,
            Redirect: false
        };
        if ( jQuery.isPlainObject( objProductFormData ) == true ) {
            jQuery.extend( objProductData, objProductFormData );
        } else if ( jQuery.type( objProductFormData ) === 'string' ) {
            objProductData.ProductID = objProductFormData;
        }
        jDocument.trigger( e4.cart.event.productadd, objProductData );
        e4.cart.ajax( {
            data: objProductData
        }, function( jsonData ) {
            if ( jCart.length === 1 ) {
                e4.cart.updateContent( jsonData );
                if ( jQuery.isArray( jsonData.cart.lastAdded ) === true ) {
                    var objProductLastAdded = jsonData.cart.lastAdded[jsonData.cart.lastAdded.length - 1],
                        strOrderlineId = e4.cart.orderline.getIdByProduct( objProductLastAdded );
                    e4.cart.orderline.setFocus( strOrderlineId );
                }
            }
            e4.cart.updateQuantityInfo( jsonData.cart.productQuantity );
            if ( typeof fnCallback === 'function' ) {
                fnCallback( jsonData );
            }
            jDocument.trigger( e4.cart.event.productadded, jsonData );
        } );
    },
    removeProduct: function() {
    },
    updateContent: function( jsonData ) {
        var jCart = jQuery( '.js-e-cart' );
        jCart.trigger( e4.cart.event.update );
        jCart.find( '.js-e-cart-orderlines' ).html( e4.handlebars.tmpl.cartOrderlines( jsonData ) );
        jCart.find( '.js-eldorado-cart-buttons' ).html( e4.handlebars.tmpl.cartButtons( jsonData ) );
        jCart.find( '.js-eldorado-cart-footer-buttons' ).html( e4.handlebars.tmpl.cartFooterButtons( jsonData ) );
        e4.cart.currentQuantity.productLinesCount = jsonData.cart.productLinesCount;
        e4.cart.currentQuantity.productQuantity = jsonData.cart.productQuantity;
        if ( jsonData.cart.hasBackorderOrderlines ) {
            e4.require.js( e4.settings.require.jQueryValidate, function() {
                e4.forms.validate.init();
            } );
        }
        jCart.find( '.js-e-order-summary' ).html( e4.handlebars.tmpl.orderSummary( jsonData ) );
        e4.cart.updateQuantityInfo( jsonData.cart.productQuantity );
        jCart.trigger( e4.cart.event.updated );

    },
    updateQuantityInfo: function( intQuantity ) {
        var jCartQuantity = jQuery( '.js-e-cart-quantity' );
        if ( jCartQuantity.length > 0 ) {
            if ( jQuery.isNumeric( intQuantity ) === false ) {
                e4.cart.ajax( {
                    method: 'GET'
                }, function( jsonData ) {
                    if ( jQuery.isNumeric( jsonData.cart.productQuantity ) === true ) {
                        e4.cart.updateQuantityInfo( jsonData.cart.productQuantity );
                    }
                }, true );
            } else if ( intQuantity === 0 ) {
                jCartQuantity.empty();
            } else {
                jCartQuantity.html( intQuantity );
            }
        }
    },
    cartHasUnsavedChanges: false,
    preventBeforeUnload: false,
    toggleCartAlert: ( shouldShow, lastEdited ) => {
        const jCartAlert = jQuery( '.js-eldorado-manual-cart-alert' );
        const jSummery = jQuery( '.js-e-order-summary' );
        const jCheckoutBtn = jQuery( 'button[type="submit"]' );
        if ( shouldShow ) {
            e4.cart.cartHasUnsavedChanges = true;
            jCartAlert.addClass( 'show' );
            jSummery.addClass( 'd-none' );
            jCheckoutBtn.prop( 'disabled', true );
        } else {
            e4.cart.cartHasUnsavedChanges = false;
            jCartAlert.removeClass( 'show alert-pulse' );
            jSummery.removeClass( 'd-none' );
            jCheckoutBtn.prop( 'disabled', false );
        }
        e4.cart.orderline.lastEdited = lastEdited;
    },
    orderline: {
        lastEdited: null,
        bindEvents: function() {
            jQuery( '.js-e-cart-form' )
                .on( 'focus blur', '.js-e-orderline-quantity-input', e4.cart.orderline.toggleFocus )
                .on( 'input', '.js-e-orderline-quantity-input', e4.util.debounce( function( event ) {
                    const jCart = jQuery( '.js-e-cart' );
                    let jElement = jQuery( event.currentTarget );
                    let inputVal = eldorado.ecom.getValidatedQuantity( jElement );
                    jElement.val( inputVal );//jElement.val().replace(/[^0-9]/g, ''));
                    if ( jCart.data( 'is-manual-cart' ).toLowerCase() === 'true' ) {
                        if ( e4.cart.orderline.manuallyUpdateCartQuantity() < 20 ) {
                            e4.cart.orderline.update( e4.cart.orderline.lastEdited );
                        } else {
                            e4.cart.toggleCartAlert( true, event.target );
                        }
                    } else {
                        e4.cart.orderline.update( event.target );
                    }

                }, e4.settings.debounceDelay.input ) )
                .on( 'input', '.js-e-orderline-comment-input', e4.util.debounce( function( event ) {
                    e4.cart.orderline.saveComment( event.target );
                }, e4.settings.debounceDelay.input * 10 ) )
                .on( 'input', '.js-e-orderline-comment-input', function( event ) {
                    e4.cart.orderline.hideCommentHelpText( event.target );
                } )
                .on( 'click', '.js-e-orderline-update-btn', function( event ) {
                    event.preventDefault();
                    const jCart = jQuery( '.js-e-cart' );
                    if ( jCart.data( 'is-manual-cart' ).toLowerCase() === 'true' ) {
                        if ( e4.cart.orderline.manuallyUpdateCartQuantity() < 20 ) {
                            e4.cart.orderline.update( e4.cart.orderline.lastEdited );
                        } else {
                            e4.cart.toggleCartAlert( true, event.target );
                        }
                    } else {
                        e4.cart.orderline.update( event.target );
                    }
                } )
                .on( 'click', '.js-e-orderline-delete-btn', function( event ) {
                    event.preventDefault();
                    const jCart = jQuery( '.js-e-cart' );
                    if ( jCart.data( 'is-manual-cart' ).toLowerCase() === 'true' ) {
                        const orderLine = event.target.closest( '.js-e-orderline' );
                        e4.cart.orderline.hideOrderLine( orderLine );
                        if ( e4.cart.orderline.manuallyUpdateCartQuantity() < 20 ) {
                            e4.cart.orderline.update( e4.cart.orderline.lastEdited );
                        } else {
                            e4.cart.toggleCartAlert( true, event.target );
                        }
                    } else {
                        e4.cart.orderline.delete( event.target );
                    }

                } );
        },
        hideOrderLine: ( domOrderLine ) => {
            domOrderLine.style.height = `${ domOrderLine.getBoundingClientRect().height }px`;
            domOrderLine.classList.add( 'js-marked-to-delete', 'marked-to-delete' );
            domOrderLine.onanimationend = () => {
                domOrderLine.classList.add( 'd-none' );
            };
        },
        manuallyUpdateCartQuantity: () => {
            const domMiniCarts = document.querySelectorAll('.js-e-cart-quantity');
            const domOrderLines = Array.from(document.querySelectorAll('.js-e-orderline')).filter(ol => ol.classList.contains('js-marked-to-delete') === false);
            let intCurrentQuantity = domOrderLines.reduce((sum, orderLine) => {
                const quantityInput = orderLine.querySelector('.js-e-orderline-quantity-input');
                const quantity = parseInt(quantityInput.value, 10);
                return sum + (isNaN(quantity) ? 0 : quantity);
            }, 0);
            domMiniCarts.forEach((domElem) =>{
                domElem.textContent = intCurrentQuantity.toString();
            })
            return domOrderLines.length;
        },
        update: function( domNode ) {
            var jOrderline = jQuery( domNode ).closest( '.js-e-orderline' ),
                intOrderlineQuantity = parseInt( jOrderline.find( '.js-e-orderline-quantity-input' ).val() );
            if ( intOrderlineQuantity !== 0 ) {
                var jForm = jOrderline.closest( '.js-e-cart-form' ),
                    jCart = jForm.closest( '.js-e-cart' ),
                    intOrderlineQuantityOriginal = parseInt( jOrderline.data( 'product-quantity' ) );
                if ( intOrderlineQuantity > intOrderlineQuantityOriginal ) {
                    jCart.trigger( e4.cart.event.orderlineincrease );
                } else if ( intOrderlineQuantity < intOrderlineQuantityOriginal ) {
                    jCart.trigger( e4.cart.event.orderlinedecrease );
                }
                jForm.find( '.js-e-cart-form-cartcmd' ).val( 'updateorderlines' );

                var objData = {};
                objData['CartCmd'] = 'updateorderlines';
                objData['Redirect'] = 'false';
                objData['OrderContext'] = jForm.find( '.js-e-cart-form-ordercontext' ).val();
                jQuery( '.js-e-orderline-quantity-input' ).each( function( intIndex, domElement ) {
                    var attrDataOriginQuantity = jQuery( domElement ).data( 'quantity' ),
                        inputQuantity = jQuery( domElement ).val() * 1;
                    if ( attrDataOriginQuantity !== inputQuantity ) {
                        objData[jQuery( domElement ).attr( 'name' )] = inputQuantity;
                    }
                    if ( domElement.closest( '.js-e-orderline' ).classList.contains( 'js-marked-to-delete' ) ) {
                        objData[jQuery( domElement ).attr( 'name' )] = 0;
                    }
                } );
                return e4.cart.ajax( {
                    data: objData
                }, function( jsonData ) {
                    e4.cart.updateContent( jsonData );
                    e4.cart.orderline.setFocus( jOrderline.attr( 'id' ) );
                    jCart.data( 'is-manual-cart', jsonData.cart.isManualCart.toString() );
                    e4.cart.toggleCartAlert( false, null );
                } );
            }
        },
        delete: function( domNode ) {
            var jCart = jQuery( '.js-e-cart' ),
                jOrderline = jQuery( domNode ).closest( '.js-e-orderline' ),
                objOrderlineData = jOrderline.data();

            jCart.trigger( e4.cart.event.orderlinedelete );
            e4.cart.ajax( {
                data: {
                    key: jOrderline.attr( 'id' ),
                    CartCmd: 'delorderline',
                    OrderContext: jCart.find( '.js-e-cart-form-ordercontext' ).val(),
                    Redirect: false
                }
            }, function( jsonData ) {
                e4.cart.updateContent( jsonData );
                jCart.trigger( e4.cart.event.orderlinedeleted, {
                    currencyCode: jsonData.cart.currencyCode,
                    name: objOrderlineData.productName,
                    number: objOrderlineData.productNumber,
                    price: objOrderlineData.productPrice,
                    quantity: objOrderlineData.productQuantity
                } );
            } );
        },
        saveComment: function( domInput ) {
            e4.cart.ajax( {
                data: [
                    domInput.name,
                    domInput.value
                ].join( '=' ),
                beforeSend: jQuery.noop
            }, function() {
                e4.cart.orderline.showCommentHelpText( domInput );
            } );
        },
        showCommentHelpText: function( domInput ) {
            jQuery( domInput ).closest( '.form-group' ).find( '.js-e-orderline-comment-help-text' ).prop( 'hidden', false );
        },
        hideCommentHelpText: function( domInput ) {
            jQuery( domInput ).closest( '.form-group' ).find( '.js-e-orderline-comment-help-text' ).prop( 'hidden', true );
        },
        setFocus: function( strId ) {
            if ( strId !== '' ) {
                var jOrderline = jQuery( '.js-e-orderline' ).filter( '#' + strId );
                if ( jOrderline.length === 1 ) {
                    //jOrderline.find( '.js-e-orderline-quantity-input' ).focus();
                }
            }
        },
        getIdByProduct: function( objProduct ) {
            var strReturnValue = '',
                jOrderline = jQuery( '.js-e-orderline' ).filter( '[data-product-id="' + objProduct.id + '"][data-product-variant-id="' + objProduct.variantId + '"]' );
            if ( jOrderline.length === 1 ) {
                strReturnValue = jOrderline.attr( 'id' );
            }
            return strReturnValue;
        },
        toggleFocus: function( event ) {
            var jOrderline = jQuery( event.target ).closest( '.js-e-orderline' );
            if ( event.type === 'focusin' ) {
                jQuery( event.target ).select();
                jOrderline.addClass( 'has-focus' );
            } else {
                jOrderline.removeClass( 'has-focus' );
            }
        }
    },
    msg: {
        timeout: null,
        init: function() {
            if ( jQuery( '#js-e-cart-msg' ).length === 1 ) {
                e4.require.js( e4.settings.require.handlebars, function() {
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-cart-msg-lastadded' );
                } );
                e4.cart.msg.bindEvents();
            }
        },
        bindEvents: function() {
            var jBody = jQuery( 'body' );
            jQuery( '#js-e-cart-msg' ).on( 'show.bs.modal', function() {
                jBody.addClass( e4.settings.modal.bodyNoAdjustmentClass );
            } ).on( 'hidden.bs.modal', function() {
                jBody.removeClass( e4.settings.modal.bodyNoAdjustmentClass );
            } ).on( 'click', function( event ) {
                if ( jQuery( event.target ).is( '#js-e-cart-msg' ) === true ) {
                    e4.cart.msg.hide();
                }
            } ).find( '.modal-dialog' ).on( 'mouseenter', e4.cart.msg.clearTimeout ).on( 'mouseleave', e4.cart.msg.setTimeout );
            jQuery( document ).on( e4.cart.event.productadded, function( event, jsonData ) {
                if ( jQuery( '.js-eldorado-quickorder-modal' ).hasClass( 'show' ) ) {
                    let jQuickorderModal = jQuery( '.js-eldorado-quickorder-modal' );
                    jQuickorderModal.find( '.js-eldorado-modal-added-to-cart-msg' ).fadeIn( 200 );
                    setTimeout( function() {
                        jQuickorderModal.find( '.js-eldorado-modal-added-to-cart-msg' ).fadeOut( 1500 );
                    }, 2500 );

                } else if ( jQuery( '.js-eldorado-bulkorder-modal' ).hasClass( 'show' ) ) {
                    let jBulkorderModal = jQuery( '.js-eldorado-bulkorder-modal' );
                    jBulkorderModal.find( '.js-eldorado-modal-added-to-cart-msg' ).fadeIn( 200 );
                    setTimeout( function() {
                        jBulkorderModal.find( '.js-eldorado-modal-added-to-cart-msg' ).fadeOut( 1500 );
                    }, 2500 );
                } else {
                    e4.cart.msg.show( jsonData );
                }
            } );
        },
        show: function( jsonData ) {
            var jCartMsg = jQuery( '#js-e-cart-msg' );
            jCartMsg.find( '.js-e-cart-msg-content' ).html( e4.handlebars.tmpl.cartMsgLastadded( jsonData ) );
            e4.cart.msg.clearTimeout();
            e4.cart.msg.setPosition();
            jCartMsg.modal( 'show' );
            e4.cart.msg.setTimeout();
        },
        hide: function() {
            e4.cart.msg.clearTimeout();
            jQuery( '#js-e-cart-msg' ).modal( 'hide' );
        },
        setPosition: function( objPosition ) {
            var jCartMsgDialog = jQuery( '#js-e-cart-msg' ).find( '.modal-dialog' ),
                jHeader = jQuery( '.js-e-header' ),
                jNavItemCart = jHeader.find( '.js-e-nav' ).find( '.js-e-nav-item-cart' ).filter( ':visible' ).first(),
                objCartMsgPosition = objPosition || {},
                objCartMsgReferencePosition = {};
            if ( jCartMsgDialog.length === 1 ) {
                if ( jQuery.isEmptyObject( objCartMsgPosition ) === true ) {
                    if ( jNavItemCart.length === 1 ) {
                        objCartMsgReferencePosition = jNavItemCart.get( 0 ).getBoundingClientRect();
                        objCartMsgPosition = {
                            top: jHeader.hasClass( 'is-hidden' ) === true ? '' : Math.floor( objCartMsgReferencePosition.bottom ),
                            right: Math.floor( jQuery( window ).width() - objCartMsgReferencePosition.right ),
                            left: '',
                            maxWidth: ''
                        };
                    } else {
                        objCartMsgPosition = {
                            top: 0,
                            right: 0,
                            left: 0,
                            maxWidth: '100%'
                        };
                    }
                }
            }
            jCartMsgDialog.css( objCartMsgPosition );
        },
        setTimeout: function() {
            e4.cart.msg.clearTimeout();
            e4.cart.msg.timeout = setTimeout( e4.cart.msg.hide, e4.settings.ecom.cart.msgHideDelay );
        },
        clearTimeout: function() {
            if ( e4.cart.msg.timeout ) {
                e4.cart.msg.timeout = clearTimeout( e4.cart.msg.timeout );
            }
        }
    }
};
